import { render, staticRenderFns } from "./add-staff.vue?vue&type=template&id=12168260&scoped=true&"
import script from "./add-staff.vue?vue&type=script&lang=js&"
export * from "./add-staff.vue?vue&type=script&lang=js&"
import style0 from "./add-staff.vue?vue&type=style&index=0&id=12168260&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12168260",
  null
  
)

export default component.exports